import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, Autocomplete, TextField, Typography, Box } from "@mui/material";
import { trackActivity } from "../../../utils/mixpanel";

const MailTemlateSection = ({ mailData, onFieldChange, isLoading, disableFields }) => {
    return (<Grid container spacing={2}>
        <Grid size={{ md: 12, xs: 12 }}>
            <TextField
                id="subject"
                label="Subject"
                variant="outlined"
                size="small"
                margin="normal"
                value={mailData?.subject || ""}
                onChange={(e) => onFieldChange("subject", e.target.value)}
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                fullWidth
                disabled={isLoading?.buttonLoader || disableFields}
            />
        </Grid>
        <Grid size={{ md: 12, xs: 12 }}>
            <TextField
                id="body"
                value={mailData?.body || ''}
                label="Content"
                variant="outlined"
                size="small"
                margin="normal"
                fullWidth
                slotProps={{ inputLabel: { shrink: true }, }}
                multiline
                rows={3}
                onChange={(e) => { onFieldChange("body", e.target.value) }}
                disabled={isLoading?.buttonLoader || disableFields}
            />
        </Grid>
    </Grid>)
}

const MailConfigurationModal = ({ isLoading, mailConfig, error, mailData, onFocusChange, dropDownLoader, userInfo, onEventToggle, onFieldChange, onToggleModal,onEditUser, onEditMailTemplate, disableFields ,assetList=[],type='',isAssetListLoading=false }) => {
    const handleItemClicked = (page_type) => { trackActivity('Item Clicked', { page_title: "MailContent Added", page_type: page_type, }) }
    const selectedAssetOptions = (Array.isArray(mailData?.asset_scope) ? mailData.asset_scope : []).reduce((acc, scope) => {
        const matchedAsset = assetList?.find((asset) =>
            String(asset?.id) === String(scope?.asset_id ?? scope?.id) &&
            String(asset?.asset_type) === String(scope?.asset_type)
        );

        if (matchedAsset) {
            acc.push(matchedAsset);
        }

        return acc;
    }, []);

    return (
        <Dialog
            onClose={onToggleModal}
            disableEscapeKeyDown
            aria-labelledby="customized-dialog-title"
            className="add-lease-dialog"
            maxWidth={"sm"}
            fullWidth
            open={mailConfig.modal}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>{mailConfig.mode === "addTemplate" ? "Mail Template" : mailConfig.mode === "addUser" ? "Notify User(s)" : "Mail Configuration"}</DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    {(mailConfig.mode === "enable" || mailConfig.mode === "addUser") ? <Grid size={{ md: 12, xs: 12 }}>
                        <Autocomplete
                            disablePortal
                            disableClearable
                            options={userInfo}
                            multiple={true}
                            value={mailData?.user_ids || []}
                            filterSelectedOptions
                            getOptionLabel={(option) => option.name || ""}
                            onChange={(e, newValue) => onFieldChange('user_ids', newValue)}
                            onFocus={() => onFocusChange("user_ids")}
                            isOptionEqualToValue={(option, value) => option.user_id === Number(value.user_id)}
                            noOptionsText={dropDownLoader ? "loading" : "No Option Available"}
                            disabled={dropDownLoader || isLoading?.buttonLoader || disableFields}
                            renderOption={(props, option) => (
                                                  <Box component="li" {...props} key={option.user_id}>
                                                    {option.name}
                                                  </Box>
                                                )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    required
                                    disabled={dropDownLoader || isLoading?.buttonLoader || disableFields}
                                    label="Notify User(s)"
                                    margin='normal'
                                    size='small'
                                    placeholder={mailData?.user_ids?.length ? "" : "Select User(s)"}
                                    error={Boolean(error?.user_ids)}
                                    helperText={error?.user_ids || ""}
                                    slotProps={{
                                        inputLabel: {
                                            shrink: true,
                                        },
                                        input: {
                                            ...params?.InputProps, endAdornment: (<>{dropDownLoader ? (<CircularProgress color="inherit" size={20} />) : null}
                                                {params?.InputProps?.endAdornment}
                                            </>
                                            )
                                        }
                                    }}
                                />
                            )}
                        />
                    </Grid> : null}
                    {((mailConfig.mode === "enable" && type === 'fleet') || mailConfig.mode === "addAsset") ? <Grid size={{ md: 12, xs: 12 }}>
                        <Autocomplete
                            disablePortal
                            options={assetList || []}
                            getOptionLabel={(option) => option?.name || ""}
                            renderOption={(props, option) => (<Box component="li" {...props} key={option.slug || option.id}> {option.name} </Box>)}
                            noOptionsText={isAssetListLoading ? "loading" : "No Option Available"}
                            multiple
                            disableCloseOnSelect
                            filterSelectedOptions
                            disabled={isAssetListLoading || isLoading?.buttonLoader || disableFields}
                            value={selectedAssetOptions}
                            onChange={(e, val) => {
                                onFieldChange('asset_scope', val)
                            }}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label='Asset(s)'
                                    margin='normal'
                                    size='small'
                                    fullWidth
                                    slotProps={{
                                        inputLabel: { shrink: true }, input: {
                                            ...params?.InputProps, endAdornment: (<>{isAssetListLoading ? (<CircularProgress color="inherit" size={20} />) : null}
                                                {params?.InputProps?.endAdornment}
                                            </>)
                                        }
                                    }}
                                />
                            )}
                        />
                    </Grid> : null}
                    {mailConfig.mode === "enable" ? <Grid size={{ md: 12, xs: 12 }}> <> <Typography className='section-header-text'><u>Mail Template:</u></Typography> <Box className="escalation-container"> <Box className="escalation-box"> <MailTemlateSection mailData={mailData} onFieldChange={onFieldChange} isLoading={isLoading} disableFields={disableFields}/> </Box> </Box> </> </Grid>: mailConfig.mode === "addTemplate" ? <Grid size={{ md: 12, xs: 12 }}> <MailTemlateSection mailData={mailData} onFieldChange={onFieldChange} isLoading={isLoading} disableFields={disableFields}/> </Grid> : null}
                </Grid>
            </DialogContent>
            <DialogActions className="dialog-action">
                <Button className="cancel-btn" disabled={isLoading?.buttonLoader} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> Cancel</Button>
                <Button variant="contained" size="small" className="btn-primary" onClick={() => { handleItemClicked('Save Button');mailConfig.mode==="addUser" ? onEditUser(mailConfig?.eventTypeId): mailConfig.mode === "addTemplate" ? onEditMailTemplate(mailConfig?.mailTemplateId) : onEventToggle(mailConfig?.checked, mailConfig?.eventTypeId) }} disabled={isLoading?.buttonLoader || dropDownLoader || disableFields}> {isLoading?.buttonLoader ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default MailConfigurationModal